import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 420px;
`
